import { Navigate, Route } from 'react-router-dom'
import ProtectedRoute from '../components/ProtectedRoute'
import RouteErrorBoundary from '../components/RouteErrorBoundary'
import Login from '../pages/Login'
import ForgotPassword from '../pages/ForgotPassword'
import ResetPassword from '../pages/ResetPassword'
import AuthCallback from '../pages/AuthCallback'
import Confirmed from '../pages/Confirmed'
import Today from '../pages/Today'
import Library from '../pages/Library'
import AddBook from '../pages/AddBook'
import BookDetail from '../pages/BookDetail'
import Quiz from '../pages/Quiz'
import Ask from '../pages/Ask'
import Settings from '../pages/Settings'

// Own module so only the app build bundles /app/* code and the auth layer.
export const appRoutes = (
  <>
    {/* Each route wrapped individually, not via a layout route: a throw must not blank the root (Chrome translate). */}
    <Route path="/login" element={<RouteErrorBoundary><Login /></RouteErrorBoundary>} />
    <Route path="/forgot-password" element={<RouteErrorBoundary><ForgotPassword /></RouteErrorBoundary>} />
    <Route path="/reset-password" element={<RouteErrorBoundary><ResetPassword /></RouteErrorBoundary>} />
    <Route path="/auth/callback" element={<RouteErrorBoundary><AuthCallback /></RouteErrorBoundary>} />
    <Route path="/auth/confirmed" element={<RouteErrorBoundary><Confirmed /></RouteErrorBoundary>} />

    <Route element={<ProtectedRoute />}>
      <Route path="/today" element={<Today />} />
      <Route path="/library" element={<Library />} />
      <Route path="/library/add" element={<AddBook />} />
      <Route path="/library/:bookId" element={<BookDetail />} />
      <Route path="/quiz" element={<Quiz />} />
      <Route path="/ask" element={<Ask />} />
      <Route path="/settings" element={<Settings />} />
    </Route>
  </>
)

// App-only build: marketing owns `/` and `*` in the combined build, so these stay out of appRoutes.
export const appEntryRoutes = (
  <>
    <Route path="/" element={<Navigate to="/today" replace />} />
    <Route path="*" element={<Navigate to="/today" replace />} />
  </>
)
